import { Text } from 'shared/ui/common/Text'
import { SocialMediaIcons } from '../SocialMediaIcons/SocialMediaIcons'

import { ReactComponent as Logo } from 'assets/logo.svg'

import s from './Footer.module.scss'

export const Footer = () => {
  return (
    <div className={s.root}>
      <div className={s.logoAndLinks}>
        <div className={s.logoWrap}>
          <Logo />
          <Text size={12} isUppercased color="secondary">
            © RociFi Labs PTE LTD
          </Text>
          {/* <a
            href="https://immunefi.com/bounty/rocifi/"
            target="_blank"
            rel="noreferrer"
          >
            Bug Bounty <br /> program <span>with</span> <br /> Immunefi
          </a> */}
        </div>
        <div className={s.links}>
          <a href="/">Home</a>
          <a href="https://blog.roci.fi/" target="_blank" rel="noreferrer">
            Blog
          </a>
          <a
            href="https://rocifi.notion.site/RociFi-Documentation-da586043665a4accac00b647e402a09e"
            target="_blank"
            rel="noreferrer"
          >
            Docs
          </a>
          <a
            href="https://join.com/companies/rocifi"
            target="_blank"
            rel="noreferrer"
          >
            Careers
          </a>
          <a
            href="https://blog.roci.fi/rocifi-protocol-litepaper-12bd2c67e5ed"
            target="_blank"
            rel="noreferrer"
          >
            Whitepaper
          </a>
          <a href="/terms-of-service" target="_blank">
            Terms of use
          </a>
          <a
            href="https://rocifi.notion.site/FAQ-bf0262c75d654b87b030ae276b9ce7ad"
            target="_blank"
            rel="noreferrer"
          >
            FAQ
          </a>

          <a
            href="https://rocifi.notion.site/Guides-81b5f4c764b94c4bb1f00e2f52c89347"
            target="_blank"
            rel="noreferrer"
          >
            Guides
          </a>
          <a
            href="https://roci.fi/app/leaderboard"
            target="_blank"
            rel="noreferrer"
            className={s.green}
          >
            Leaderboard
          </a>
          <a
            href="https://blog.roci.fi/rocifi-launches-nfcs-api-83daebe89ade"
            target="_blank"
            rel="noreferrer"
          >
            API
          </a>
        </div>
      </div>
      <SocialMediaIcons />
    </div>
  )
}
